module.exports = "/_next/static/images/ce4ddadc35769e216776a08f76846c3c-phone-md.png.webp";